import * as React from 'react';
import { SVGProps } from 'react';

const IconPhoneSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.672 8.989a8.416 8.416 0 0 1-3.66-3.661l1.112-.83a1 1 0 0 0 .375-1.031L4.1 1.77A1 1 0 0 0 3.125 1h-1.57A.557.557 0 0 0 1 1.556 9.444 9.444 0 0 0 10.444 11c.306 0 .556-.25.556-.556v-1.57a1 1 0 0 0-.768-.974l-1.697-.403a1 1 0 0 0-1.034.376L6.672 8.99z" />
  </svg>
);
export default IconPhoneSizeXs;
